import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivateChatComponent } from './pages/private-chat/private-chat.component';
import { EventNavViewComponent } from './layout/event-nav-view/event-nav-view.component';
import { ContactsComponent } from './pages/contacts/contacts.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { EventScheduleComponent } from './pages/event-schedule/event-schedule.component';
import { EventTicketsComponent } from './pages/event-tickets/event-tickets.component';
import { ExpoDetailsComponent } from './pages/expo/expo-details/expo-details.component';
import { ExpoListComponent } from './pages/expo/expo-list/expo-list.component';
import { ExpoStudioComponent } from './pages/expo/expo-studio/expo-studio.component';
import { NetworkingListComponent } from './pages/networking-list/networking-list.component';
import { NetworkRoomComponent } from './pages/network-room/network-room.component';
import { ClaimTicketComponent } from '../landing-pages/consumer/claim-ticket/claim-ticket.component';
import { NetworkAdminComponent } from './pages/network-admin/network-admin.component';


const routes: Routes = [
  {
    path: "",
    component: EventNavViewComponent,
    children: [
      {
        path: ":slug_name",
        component: EventDetailsComponent,
      },
      {
        path: "home/:slug_name/:ticket_key",
        component: EventDetailsComponent,
      },
      {
        path: ":slug_name/place-order",
        component: EventTicketsComponent
      },
      {
        path: ":slug_name/place-order/:ticket_key",
        component: EventTicketsComponent
      },
      {
        path: "schedule/:ticket_key",
        component: EventScheduleComponent
      },
      {
        path: "expo-list/:ticket_key",
        component: ExpoListComponent,
      },
      {
        path: "expo-details/:id/:ticket_key",
        component: ExpoDetailsComponent,
      },
      {
        path: "expo-room/:room_token/:expo_id/:session_id/:ticket_key",
        component: ExpoStudioComponent,
      },
      {
        path: "private-chat/:ticket_key",
        component: PrivateChatComponent,
      },
      {
        path: "contacts/:ticket_key",
        component: ContactsComponent,
      },
      {
        path: "networking-list/:ticket_key",
        component: NetworkingListComponent,
      },
      {
        path: "networking-list/:ticket_key/:room_id",
        component: NetworkingListComponent,
      },
      {
        path: "network-room/:room_id/:session_id/:ticket_key",
        component: NetworkRoomComponent,
      },
      {
        path: "network-admin/:room_id/:session_id/:ticket_key",
        component: NetworkAdminComponent,
      },
      { path: "claim-tickets/:ticket_key", component: ClaimTicketComponent },
      // {
      //   path: "",
      //   redirectTo: "event-home",
      //   pathMatch: "full",
      // },

    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EventNavigationRoutingModule { }
